import React from 'react';

import { Row, Button } from 'antd';
import classnames from 'classnames';

import Ribbon from 'pages/home/ribbon';
import { Slot, GridStyleLayout } from 'common/components';

// import EntitySearch from './EntitySearch';
import EntitySearch from 'pages/home/components/fields/Search';
import SearchFilterRadio from 'pages/home/components/fields/SearchFilterRadio';

import './LayoutMainPage.less';

const LayoutMainPage = ({
  className,
  title,
  searchCriteria,
  searchText,
  onSearch,
  showFilter,
  children,
}) => {
  const hasSearch = typeof searchText === 'string';

  return (
    <GridStyleLayout className='main__layout' rows='0 auto auto 1fr'>
      <div
        className={classnames('main__title', {
          'main__title--visible': !!title,
        })}
      >
        {title ? (
          <Button className='main__title-btn' type='link' icon={title?.icon}>
            {title?.text}
          </Button>
        ) : null}
      </div>

      <Ribbon>{children}</Ribbon>

      <Row className='main__entity-search' align='middle'>
        {hasSearch || onSearch ? (
          <>
            <EntitySearch
              // searchText={searchText}
              // primaryFieldsOnly={primaryFieldsOnly}
              searchCriteria={searchCriteria}
              handleSearch={onSearch}
            />
            {showFilter ? <SearchFilterRadio /> : null}
          </>
        ) : null}
      </Row>
      <div
        className={classnames('main__content scroller--y', className)}
        style={{
          height: '100%',
          position: 'relative',
          padding: 4,
        }}
      >
        <Slot name='content'>{children}</Slot>
      </div>
    </GridStyleLayout>
  );
};

export default LayoutMainPage;
